import type { ReactNode } from 'react';

import type { ButtonOrLinkDataProps } from '#/components/ButtonOrLink/ButtonOrLinkData';

import { StyledPageHeaderButton } from './PageHeaderButton.styled';

type Props = ButtonOrLinkDataProps<{
  children: ReactNode;
  className?: string;
  variant:
    | 'grey'
    | 'blue'
    | 'secondary'
    | 'green'
    | 'white'
    | 'blueGreenAnimate';
  minWidth?: number;
  smallHorizontalPadding?: boolean;
  centerHorizontally?: boolean;
  qaId?: string;
  ariaLabel?: string;
  roundBottomWhenOpen?: boolean;
}>;

export function PageHeaderButton({
  children,
  className,
  variant,
  minWidth,
  smallHorizontalPadding,
  centerHorizontally,
  qaId,
  ariaLabel,
  roundBottomWhenOpen,
  ...otherProps
}: Props) {
  return (
    <StyledPageHeaderButton
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
      $variant={variant}
      $smallHorizontalPadding={Boolean(smallHorizontalPadding)}
      $roundBottomWhenOpen={Boolean(roundBottomWhenOpen)}
      $centerHorizontally={Boolean(centerHorizontally)}
      style={{ minWidth }}
      qaId={qaId}
      aria-label={ariaLabel}
      className={className}
    >
      {children}
    </StyledPageHeaderButton>
  );
}
